export const TENURES = {
  MONTHLY: 1,
  YEARLY: 12,
  QUARTERLY: 3,
};
